import React, { Component, useState, useEffect } from 'react';
import { FaHome, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import axios from 'axios';
import './Menu.css';
import toast, { Toaster } from 'react-hot-toast';
import Profile from './Profile';

const Menu = ({ handleSetShowWizard, handleWizardFarmChanged }) => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [supplyCompany, setSupplyCompany] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [ruralProfessionalOrganisation,setRuralProfessionalOrganisation] = useState(false);
    const [isLicensedforEnterpriseDashboard, setIsLicensedforEnterpriseDashboard] = useState(false);
    const [role, setRole] = useState('');
    const [farmCount, setFarmCount] = useState(0);
    const [isIconUp, setIsIconUp] = useState(false);
    const [tcAccepted, setTCAccepted] = useState(false);
    const [defaultFarmName, setDefaultFarmName] = useState();
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useState();
    useEffect(() => {
        setDefaultFarmName(JSON.parse(localStorage.getItem("defaultFarmName")))
        setDefaultFarmUniqueId(JSON.parse(localStorage.getItem("defaultFarmUniqueId")))
        OnPageload();
    })
    const toggle = () => {
        setIsIconUp(!isIconUp);
        handleSetShowWizard()
    };
    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/settings/GetMyInfoView/', {
                    params: { Id: farmId, UserId: userId }
            }
            );
            if (response.data.status) {
                setSupplyCompany(response.data.content.supplyCompany);
                setRuralProfessionalOrganisation(response.data.content.ruralProfessionalOrganisation);
                setRole(response.data.content.role);
                setFarmCount(response.data.content.farmCount);
                setTCAccepted(response.data.content.tcAccepted);
                setIsLicensedforEnterpriseDashboard(response.data.content.isLicensedforEnterpriseDashboard);
            }

        } catch (err) {
            console.log(err);
        }
    }
    const handleSetFarm = async (id) => {
        const farmId = parseInt(id);
        try {
            const response = await axios.get(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            localStorage.setItem("defaultFarmId", JSON.stringify(id));
            localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleClick = async (e) => {
        e.preventDefault(); // Prevents the default anchor behavior (e.g., navigation)
        try {
            const response = await axios.get(
                '/api/settings/GetUsers/', {
                params: {}
            }
            );
            if (response.data != null) {
                var user = response.data.content.users.filter(x => x.id == userId);
                if (user[0].userFarmList.length == 1) {
                    await handleSetFarm(user[0].userFarmList[0].id);
                }
                else if (user[0].userFarmList.length > 0) {
                    window.open("/allfarmssummary", "_self");
                }
                else {
                    toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleWizardFarmChanged1 = async (event, farmid) => {
        event.preventDefault();
        try {
            const response = await axios.get(
                '/api/wizard/GetWizardDetails/', {
                params: {
                    farmId: farmid
                }
            }
            );
            if (response.data != null) {
                var landingPage = response.data.landingPage;
                window.open(landingPage, "_self");
            }
        } catch (error) {

            console.error('Error:', error);
        }

    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <div className="navigation-menu" style={{ marginLeft: "5px", marginRight: "5px" }}>
                <div className="container" style={{ display: "flex", padding: "7px", justifyContent: "space-between" }}>
                    <div style={{ display: "flex" }}>
                        <div className="header-logoMenu">
                            <img className="logoMenu" src="/images/fwfp-logo-white-text-fixed.png" />
                        </div>
                        <ul id="menu" class= "marginbottom" style={{ marginLeft: "25px", display: "flex"}}>
                            <li><a className="link" target="_blank" rel="noreferrer" href="https://support.freshwaterfarmplan.co.nz/">User Guides</a></li>
                            {isLicensedforEnterpriseDashboard &&
                                <li><a className="link" href="/enterpriseinsights">Enterprise Insights</a></li>
                            }
                            {role == 'Admin' &&
                                <li><a className="link" href="/allfarmssummary">All Farms Summary</a></li>
                            }
                            {
                                tcAccepted && farmCount > 1 && (role == 'Organization User' || role == 'Farm User') &&
                                <li><a className="link" href="/allfarmssummary">All Farms Summary</a></li>
                            }
                            <div class="right-arrow">&#x25BA;</div>&nbsp;&nbsp;&nbsp;<li><a href="/" className="link" onClick={(e) => handleWizardFarmChanged1(e, farmId)}>{defaultFarmName}&nbsp;&nbsp; <span className="farm-unique-id" style={{ color: "#52AFB5", fontSize: "16px" }}>{farmId != 0 && <>ID: {defaultFarmUniqueId}</>}</span></a></li>
                        </ul>
                    </div>
                    <div><Profile/></div>
                    {/*<div title="Click to show menu" onClick={toggle} className="toggleoutlineMenu">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</div>*/}
                </div>
            </div>
        </div>
    );
}
export default Menu